module.exports = __webpack_public_path__ + "img/XLM.a4294f69.svg";